import { Badge } from '@/components/ui/badge';
import { UNATTENDED_FLAG_LABEL, type UnattendedFlagKind } from '@/lib/timer/unattendedFlags';

/** B-T1: the server's flags on one open unattended operation, as labelled badges (nothing when there are none). */
export function UnattendedFlagBadges({ flags }: { flags?: readonly UnattendedFlagKind[] | null }) {
  if (!flags || flags.length === 0) return null;
  return (
    <>
      {flags.map((f) => (
        <Badge key={f} variant="destructive" className="text-[10px]" data-testid={`unattended-flag-${f}`}>
          {UNATTENDED_FLAG_LABEL[f]}
        </Badge>
      ))}
    </>
  );
}
